import FluidImage from './FluidImage';
import FixedImage from './FixedImage';

export { FluidImage, FixedImage };
